//import { Path } from '../routes'
import * as types from '../constants/Action_types'

const initialState = {
    configuration: null
}

export default function (state = initialState, action) {

    switch (action.type) {

        case types.GET_CONFIGURATION:
            return {
                ...state,
              configuration: action.payload
            }
        default:
            return state
    }
}

